<template>
  <v-badge :color="color" :left="left" :bottom="bottom" :overlap="overlap">
    <template v-slot:badge>
      <!-- @slot This is the badge itself, it can have content such as an icon or text -->
      <slot name="badge-content"></slot>
    </template>
    <!-- @slot This is whatever the badge attaches itself to, it could be another icon or even text -->
    <slot name="badge-anchor"></slot>
  </v-badge>
</template>

<script>
/**
 * The Badge component can wrap any type of content to highlight information to a user or to just draw attention to a specific element.
 */
export default {
  name: "NsBadge",
  props: {
    /**
     * Applies specified color to the control - it can be the name of material color (for example `success` or `purple`) or css color (`#033` or `rgba(255, 0, 0, 0.5)`)
     * NOTE: at the moment we cannot use colors such as `primary` or `secondary` as these are globally assuming button styling.
     */
    color: {
      type: String,
      default: "#008AB0"
    },
    /**
     * Align the component towards the left
     */
    left: {
      type: Boolean,
      default: false
    },
    /**
     * Align the component towards the bottom
     */
    bottom: {
      type: Boolean,
      default: false
    },
    /**
     * Component will overlap the slotted content
     */
    overlap: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss">
</style>